import { MonitorsRouter } from 'areas/assets/monitors/bundleDescription';
import { MonitorType } from 'areas/assets/monitors/monitorType';
import { RouteEntry } from 'framework/routing/routeEntry';

import { EventLogMonitorPageProps } from 'areas/monitors/event-log-monitor/event-log-monitor-page/types';

// noinspection JSUnusedGlobalSymbols
export function getRoute(): RouteEntry<EventLogMonitorPageProps> {
	return {
		url: MonitorsRouter.list(MonitorType.WindowsEvents) + '/:id',
		getModuleImport: async () =>
			await import('areas/monitors/event-log-monitor/event-log-monitor-page/eventLogMonitorPage'),
		routeId: 'monitors_event-log-new',
	};
}
